// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"72f1faac","239":"6a43acfe","453":"765bac7a","455":"bb3e6572"}[chunkId] + ".chunk.js";
};